import React, { createContext, useState, useContext } from 'react';

interface OtpContextType {
  isOtpModalVisible: boolean;
  showOtpModal: () => void;
  hideOtpModal: () => void;
  onOtpSuccess: (() => void) | null;
  onOtpError: (() => void) | null;
  setOtpSuccessCallback: (callback: () => void) => void;
  setOtpErrorCallback: (callback: () => void) => void;
  fromScreen: string;
  setFromScreen: (screen: string) => void;
}

const OtpContext = createContext<OtpContextType | undefined>(undefined);

export const OtpProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOtpModalVisible, setIsOtpModalVisible] = useState(false);
  const [onOtpSuccess, setOnOtpSuccess] = useState<(() => void) | null>(null);
  const [onOtpError, setOnOtpError] = useState<(() => void) | null>(null);
  const [fromScreen, setFromScreen] = useState<string>('');

  const showOtpModal = () => {
    setIsOtpModalVisible(true);
  };

  const hideOtpModal = () => {
    setIsOtpModalVisible(false);
    // Clear the callbacks when hiding the modal
    setOnOtpSuccess(null);
    setOnOtpError(null);
  };

  const setOtpSuccessCallback = (callback: () => void) => {
    setOnOtpSuccess(() => callback);
  };

  const setOtpErrorCallback = (callback: () => void) => {
    setOnOtpError(() => callback);
  };

  return (
    <OtpContext.Provider 
      value={{ 
        isOtpModalVisible,
        showOtpModal,
        hideOtpModal,
        onOtpSuccess,
        onOtpError,
        setOtpSuccessCallback,
        setOtpErrorCallback,
        fromScreen,
        setFromScreen
      }}
    >
      {children}
    </OtpContext.Provider>
  );
};

export const useOtp = (): OtpContextType => {
  const context = useContext(OtpContext);
  if (context === undefined) {
    throw new Error('useOtp must be used within an OtpProvider');
  }
  return context;
};
